/**
 * @typedef {import('../../../../App/shared/SubscriptionService/CheckoutSession').default} CheckoutSession
 * @typedef {import('./Response').default} Response
 */

import { subscriptionService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {string} groupId
 * @returns {Response}
 */
export default function useGetGroupCheckoutLinks(groupId) {
	const [checkoutLinks, setCheckoutLinks] = useState(
		/** @type {CheckoutSession | null} */ (null)
	);
	const [isGettingData, setIsGettingData] = useState(true);

	useEffect(() => {
		if (!groupId) {
			setIsGettingData(false);
			return;
		}

		getCheckoutLinks();
	}, [groupId]);

	async function getCheckoutLinks() {
		setIsGettingData(true);

		try {
			const checkoutSessions =
				await subscriptionService.getGroupSubscriptionCheckoutLink(
					groupId
				);

			setCheckoutLinks(checkoutSessions);
		} catch (error) {
			captureError(error);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: checkoutLinks,
			isGettingData,
		}),
		[isGettingData, checkoutLinks]
	);
}
